export default class Modal {
    constructor(triggers, modal) {
        this.elements = {
            triggers: triggers,
            modal: modal
        };

        this.elements.box = this.elements.modal.querySelector(".js-modal-box");

        this.elements.close = this.elements.modal.querySelectorAll(
            ".js-modal-close"
        );

        if (!this.elements.triggers.length || !this.elements.modal) {
            return;
        }

        this.openModal = this.openModal.bind(this);
        this.closeModal = this.closeModal.bind(this);
        this.handleDocumentClick = this.handleDocumentClick.bind(this);

        this._setDOMReferences();
    }

    _setDOMReferences() {
        for (let i = 0; i < this.elements.triggers.length; i++) {
            const trigger = this.elements.triggers[i];
            trigger.addEventListener("click", this.openModal);
        }
        for (let i = 0; i < this.elements.close.length; i++) {
            const element = this.elements.close[i];
            element.addEventListener("click", this.closeModal);
        }
    }

    openModal() {
        this.elements.modal.classList.add("is--open");
        document.addEventListener("click", this.handleDocumentClick, true);
    }

    handleDocumentClick(event) {
        if (!this.elements.box.contains(event.target)) {
            this.closeModal();
        }
    }

    closeModal() {
        this.elements.modal.classList.remove("is--open");
        document.removeEventListener("click", this.handleDocumentClick, true);
    }
}
